/** alarmSetting */
import React from 'react';
import { Table, Space } from 'antd';

class ComTable extends React.Component{
  state = {
    loading: false,
    page: 1,
    size: 30,
    tbData: [],
    pagination: {
      current: 1,
      pageSize: 30,
      defaultPageSize: 30,
      pageSizeOptions: [30, 50, 100],
      total: 0,
      showSizeChanger: true,
      showQuickJumper: true,
      showTotal: total => `共 ${total} 条数据`,
    }
  };
  columns = [
    {
      title: 'ID',
      dataIndex: 'name',
    }, {
      title: '报警标准',
      dataIndex: 'chinese',
    }, {
      title: '通知方式',
      dataIndex: 'math',
    }, {
      title: '操作',
      width: 180,
      dataIndex: 'english',
      render: (val, row, index) => (
        <Space size="middle">
          <span className="c-primary cursor-no-select" onClick={() => this.tbOpt('save', val, row, index)}>生效</span>
          <span className="c-primary cursor-no-select" onClick={() => this.tbOpt('edit', val, row, index)}>编辑</span>
          <span className="c-primary cursor-no-select" onClick={() => this.tbOpt('del', val, row, index)}>删除</span>
        </Space>
      ),
    },
  ];
  tbOpt = (text, record, index) => {
    console.log('tbOpt', text, record, index);
  };
  onChange = (pagination, filters, sorter, extra) => {
    this.setState({
      tbFilter: Object.assign(this.state.tbFilter, {
        page: pagination.current,
        size: pagination.pageSize
      })
    });
  };
  UNSAFE_componentWillMount = () => {
    this.setState({
      tbData: [
        {
          key: '1',
          name: 'John Brown',
          chinese: 98,
          math: 60,
          english: 70,
        }, {
          key: '2',
          name: 'Jim Green',
          chinese: 98,
          math: 66,
          english: 89,
        }, {
          key: '3',
          name: 'Joe Black',
          chinese: 98,
          math: 90,
          english: 70,
        }, {
          key: '4',
          name: 'Jim Red',
          chinese: 88,
          math: 99,
          english: 89,
        }
      ]
    });
  };
  render() {
    const { tbData, pagination, loading } = this.state;
    return (
      <div>
        <Table bordered loading={loading} pagination={pagination}
          columns={this.columns} dataSource={tbData} onChange={this.onChange} />
      </div>
    );
  }
};
export default ComTable;
